<div class="section section-dark chiffres">
  <div class="container-xl">
    <div class="section-title">
      <h1 class="title">{{ pageSeo?.titre }}</h1>
      <h2 class="subtitle">{{ pageSeo?.titre_chiffres_cles }}</h2>
    </div>
    <div class="section-content">
      <div [innerHTML]="pageSeo?.chiffres_cles | markdown"></div>
    </div>
  </div>
</div>

<!-- Discover -->
<b2b-ui-section-discover
  [text]="ctaSeo?.CTA1"
  [linkText]="ctaSeo?.intitule_CTA1"
  [linkUrl]="ctaSeo?.cible_CTA1"
></b2b-ui-section-discover>

<section class="section description">
  <div class="container-xl">
    <div class="section-title">
      <h3 class="subtitle">{{ pageSeo?.titre_paragraphe_1 }}</h3>
    </div>
    <div class="section-content">
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start start" fxLayoutGap="30px">
        <div class="section-left" fxFlex="50">
          <div class="text-justify" [innerHTML]="pageSeo?.paragraphe1A | markdown"></div>
        </div>
        <div class="section-right" fxFlex="50">
          <div class="text-justify" [innerHTML]="pageSeo?.paragraphe1B | markdown"></div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section description">
  <div class="container-xl">
    <div class="section-title">
      <h3 class="subtitle">{{ pageSeo?.titre_paragraphe_2 }}</h3>
    </div>
    <div class="section-content">
      <div class="text-justify" [innerHTML]="pageSeo?.paragraphe2 | markdown"></div>
    </div>
  </div>
</section>

<!-- Discover -->
<b2b-ui-section-discover
  [text]="ctaSeo?.CTA2"
  [linkText]="ctaSeo?.intitule_CTA2"
  [linkUrl]="ctaSeo?.cible_CTA2"
></b2b-ui-section-discover>

<section class="section description">
  <div class="container-xl">
    <div class="section-title">
      <h3 class="subtitle">{{ pageSeo?.titre_paragraphe_3 }}</h3>
    </div>
    <div class="section-content">
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start start" fxLayoutGap="30px">
        <div class="section-left" fxFlex="50">
          <div class="text-justify" [innerHTML]="pageSeo?.paragraphe3A | markdown"></div>
        </div>
        <div class="section-right" fxFlex="50">
          <div class="text-justify" [innerHTML]="pageSeo?.Paragraphe3B | markdown"></div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="section-dark section-gradient">
  <section class="section description">
    <div class="container-xl">
      <div class="section-title">
        <h3 class="subtitle">{{ pageSeo?.titre_paragraphe_4 }}</h3>
      </div>
    </div>
    <div class="section-content" fxHide.lt-md>
      <div class="gradient-bg"></div>
      <div class="container-xl" fxLayout="row" fxLayoutAlign="start strecht" fxLayoutGap="60px">
        <div class="section-left" #sectionLeft fxFlex="50">
          <div class="text-justify" [innerHTML]="pageSeo?.paragraphe4A | markdown"></div>
        </div>
        <div class="section-right" fxFlex="grow">
          <div class="text-justify" [innerHTML]="pageSeo?.paragraphe4B | markdown"></div>
          <div fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
            <a [href]="ctaSeo?.cible_CTA2" class="btn btn-rounded btn-action">En savoir plus</a>
          </div>
        </div>
      </div>
    </div>
    <div class="section-content" fxLayout.lt-md="column" fxLayoutGap="60px" fxHide fxShow.lt-md>
      <div class="section-left" fxFlex="50">
        <div class="gradient-bg"></div>
        <div class="container-xl">
          <div class="text-justify" [innerHTML]="pageSeo?.paragraphe4A | markdown"></div>
        </div>
      </div>
      <div class="section-right" fxFlex="50">
        <div class="container-xl">
          <div class="text-justify" [innerHTML]="pageSeo?.paragraphe4B | markdown"></div>
          <div fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center">
            <a [href]="ctaSeo?.cible_CTA2" class="btn btn-rounded btn-action">En savoir plus</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section meta">
    <div class="container-xl">
      <ul class="list-unstyled">
        <li class="mb-4" *ngIf="pageSeo?.source_chiffres_cles">
          Sources de chiffres clés: <span [innerHTML]="pageSeo?.source_chiffres_cles | markdown"></span>
        </li>
        <li *ngIf="pageSeo?.author?.username">
          Auteur: <span>{{ pageSeo?.author?.username }}</span>
        </li>
        <li *ngIf="pageSeo?.created_at">
          Date de publication: <span>{{ pageSeo?.created_at | date: 'dd/MM/yyyy' }}</span>
        </li>
        <li *ngIf="pageSeo?.revision_author?.username">
          Auteur de la révision: <span>{{ pageSeo?.revision_author?.username }}</span>
        </li>
        <li *ngIf="pageSeo?.updated_at">
          Date de révision: <span>{{ pageSeo?.updated_at | date: 'dd/MM/yyyy' }}</span>
        </li>
      </ul>
    </div>
  </section>
</div>

<section class="section description" *ngIf="pageSeo?.children.length > 0">
  <div class="container-xl">
    <header class="section-title">
      <h2 class="subtitle">À voir aussi</h2>
    </header>
    <div class="section-content">
      <ul class="links unstyled-list">
        <li *ngFor="let child of pageSeo.children; trackBy: trackByFn">
          <a
            rel="canonical"
            [routerLink]="['/page/' + child.slug]"
            [queryParams]="{ parent: pageSeo?.id }"
            class="link"
            >{{ child.titre }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- Garanties -->
<b2b-ui-section-garantee></b2b-ui-section-garantee>
